import { createFileRoute } from '@tanstack/react-router'

import { GlobalRoleType } from '@beaded/models'

import { requireGlobalRole } from 'lib/routeGuards'

import LoggerFirmwareManagement from 'pages/LoggerFirmwareManagement'

export const Route = createFileRoute(
  '/_auth/_global/logger-firmware-management',
)({
  beforeLoad: requireGlobalRole(
    GlobalRoleType.LOGGER_ADMIN,
    GlobalRoleType.GLOBAL_ADMIN,
  ),
  component: LoggerFirmwareManagement,
})
